import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";
import { Turnstile } from "@marsidev/react-turnstile";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isForgot, setIsForgot] = useState(false);
  const navigate = useNavigate();
  const [turnstileToken, setTurnstileToken] = useState(null);

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          (e.key === "I" || e.key === "J" || e.key === "C")) ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleConfirmPasswordChange = (e) => {
    const val = e.target.value;
    setConfirmPassword(val);

    if (isRegistering) {
      if (val.length > 0 && password !== val) {
        setError("Lozinke se ne podudaraju.");
      } else {
        setError(null);
      }
    }
  };

  const handlePasswordChange = (e) => {
    const val = e.target.value;
    setPassword(val);

    if (isRegistering && confirmPassword.length > 0) {
      if (val !== confirmPassword) {
        setError("Lozinke se ne podudaraju.");
      } else {
        setError(null);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    const cleanEmail = email.trim().toLowerCase();

    if (!turnstileToken) {
      setError("Molimo potvrdite da niste bot.");
      return;
    }

    setLoading(true);

    try {
      if (isForgot) {
        // --- ZABORAVLJENA LOZINKA ---
        const { data: invite, error: inviteError } = await supabase
          .from("invited_organizers")
          .select("email")
          .eq("email", cleanEmail)
          .maybeSingle();

        if (inviteError || !invite) {
          throw new Error(
            "Ovaj e-mail ne postoji u bazi ovlaštenih organizatora.",
          );
        }

        const { error: resetError } = await supabase.auth.resetPasswordForEmail(
          cleanEmail,
          {
            redirectTo: `${window.location.origin}/resetiraj-lozinku`,
          },
        );

        if (resetError) throw resetError;

        setSuccessMessage(
          "Upute za resetiranje lozinke poslane su na vaš e-mail.",
        );
        setEmail("");
      } else if (isRegistering) {
        // --- REGISTRACIJA ---
        if (password !== confirmPassword) {
          setError("Lozinke se ne podudaraju.");
          setLoading(false);
          return;
        }

        const { data: invite, error: inviteError } = await supabase
          .from("invited_organizers")
          .select("email")
          .eq("email", cleanEmail)
          .maybeSingle();

        if (inviteError || !invite) {
          throw new Error("Ovaj e-mail nije ovlašten za registraciju.");
        }

        const { data, error: signUpError } = await supabase.auth.signUp({
          email: cleanEmail,
          password: password,
          options: {
            data: {
              turnstileToken: turnstileToken,
            },
          },
        });

        if (signUpError) throw signUpError;

        if (data.user) {
          const { error: dbError } = await supabase
            .from("admin_users")
            .upsert(
              [{ id: data.user.id, email: cleanEmail, role: "organizer" }],
              { onConflict: "id" },
            );

          if (dbError) throw dbError;
        }

        navigate("/admin-panel");
      } else {
        // --- PRIJAVA ---
        const { data, error: authError } =
          await supabase.auth.signInWithPassword({
            email: cleanEmail,
            password: password,
          });

        if (authError) {
          throw new Error("Neispravan e-mail ili lozinka.");
        }

        const userId = data.user.id;

        let { data: profile } = await supabase
          .from("admin_users")
          .select("role")
          .eq("id", userId)
          .maybeSingle();

        if (!profile) {
          const { data: invite } = await supabase
            .from("invited_organizers")
            .select("email")
            .eq("email", cleanEmail)
            .maybeSingle();

          if (invite) {
            const { error: insertError } = await supabase
              .from("admin_users")
              .upsert([{ id: userId, email: cleanEmail, role: "organizer" }], {
                onConflict: "id",
              });

            if (!insertError) {
              profile = { role: "organizer" };
            }
          }
        }

        if (!profile) {
          await supabase.auth.signOut();
          throw new Error("Nemate dozvolu pristupa.");
        }

        if (profile?.role && profile.role.trim().toLowerCase() === "owner") {
          navigate("/fucascore-admin");
        } else {
          navigate("/admin-panel");
        }
      }
    } catch (err) {
      let errorMsg = err.message;
      if (errorMsg.includes("Invalid login credentials")) {
        errorMsg = "Neispravan e-mail ili lozinka.";
      }
      setError(errorMsg || "Došlo je do pogreške pri obradi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img src={FucaScoreLogo} alt="FucaScore logo" className="logo" />
        <h2>
          {isForgot
            ? "Zaboravljena lozinka"
            : isRegistering
              ? "Registracija"
              : "Admin Pristup"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="input-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {!isForgot && (
            <div className="input-field">
              <label>Lozinka</label>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={handlePasswordChange}
                  required
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  <i
                    className={
                      showPassword ? "fi fi-rs-eye" : "fi fi-rs-crossed-eye"
                    }
                  ></i>
                </span>
              </div>
            </div>
          )}

          {!isForgot && isRegistering && (
            <div className="input-field">
              <label>Potvrdi lozinku</label>
              <div className="password-container">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  required
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i
                    className={
                      showConfirmPassword
                        ? "fi fi-rs-eye"
                        : "fi fi-rs-crossed-eye"
                    }
                  ></i>
                </span>
              </div>
            </div>
          )}

          {error && <p className="error-msg">{error}</p>}
          {successMessage && <p className="success-msg">{successMessage}</p>}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "15px 0",
            }}
          >
            <Turnstile
              siteKey="0x4AAAAAAD-bRw2DrEn7ycda"
              theme="dark"
              options={{ theme: "dark" }}
              onSuccess={(token) => setTurnstileToken(token)}
              onExpire={() => setTurnstileToken(null)}
            />
          </div>

          <button
            type="submit"
            disabled={
              loading || (isRegistering && password !== confirmPassword)
            }
          >
            {loading
              ? "Obrada..."
              : isForgot
                ? "Pošalji link za reset"
                : isRegistering
                  ? "Registriraj se"
                  : "Prijavi se"}
          </button>
        </form>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            marginTop: "15px",
            textAlign: "center",
          }}
        >
          {!isForgot && (
            <p
              style={{
                cursor: "pointer",
                fontSize: "0.85rem",
                color: "#8899a6",
              }}
              onClick={() => {
                setIsForgot(true);
                setError(null);
                setSuccessMessage(null);
              }}
            >
              Zaboravili ste lozinku?
            </p>
          )}

          <p
            style={{ cursor: "pointer", fontSize: "0.9rem" }}
            onClick={() => {
              if (isForgot) {
                setIsForgot(false);
              } else {
                setIsRegistering(!isRegistering);
              }
              setError(null);
              setSuccessMessage(null);
              setEmail("");
            }}
          >
            {isForgot
              ? "Natrag na prijavu"
              : isRegistering
                ? "Već imaš račun? Prijavi se"
                : "Nemaš račun? Registriraj se"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
